import React from 'react';

type Props = {
  resetErrorBoundary?: () => void;
};
const ErrorScreen = ({ resetErrorBoundary }: Props) => (
  <div
    style={{
      textAlign: 'center',
      fontFamily: 'Helvetica, Arial',
      paddingTop: '4rem',
    }}
  >
    <img src="/public/images/5xx.png" alt="500" />
    <h1>Oops! We&apos;ve encountered an unexpected error</h1>

    <p>
      We&apos;ve logged the problem and we are working hard to resolve any
      issues.
    </p>
    <p>
      You may try to{' '}
      <button type="button" onClick={() => resetErrorBoundary?.()}>
        reload
      </button>{' '}
      the page.
    </p>
  </div>
);

export default ErrorScreen;
